import { PayloadAction } from '@reduxjs/toolkit';

import { FlatPreview, PreviewState } from 'editor/src/store/editorModules/preview/types';

const setFlatPreviewsReducer = (state: PreviewState, action: PayloadAction<Array<FlatPreview>>) => {
  state.flatPreviews = action.payload;
};

export default setFlatPreviewsReducer;
